function LoadingIndicator() {
  return (
    <div className="loader-screen">
      <div className="loader-word" aria-label="Dolapo Olakanmi">
        Dolapo Olakanmi
      </div>
    </div>
  );
}

export default LoadingIndicator;
